import { useDispatch, useSelector } from "react-redux";

import GenerateAiDecisionButton from "../../../../common/GenerateAiDecisionButton/GenerateAiDecisionButton";
import DisplayAiDecision from "../../../../common/DisplayAiDecision/DisplayAiDecision";

import { RequestGenerateAIDecision } from "../../../../../store/actions/analysisReportActions";

const AiDecision = ({ id }) => {
  const dispatch = useDispatch();

  const aiDecision = useSelector((state) => state.analysisReports.generatedAiDecision);
  const aiDecisionLoading = useSelector(
    (state) => state.analysisReports.generatedAiDecisionLoading,
  );
  const generatingAiDecision = useSelector(
    (state) => state.analysisReports.generateAiDecisionLoading,
  );

  const generateAIDecisionHandler = () => {
    if (!id) return;
    if (generatingAiDecision) return;
    dispatch(RequestGenerateAIDecision(id));
  };

  return (
    <div className="ai-decision">
      <GenerateAiDecisionButton
        onClick={generateAIDecisionHandler}
        loading={generatingAiDecision}
        disabled={aiDecisionLoading}
      />

      <DisplayAiDecision
        aiDecision={aiDecision}
        aiDecisionLoading={aiDecisionLoading}
        generatingAiDecision={generatingAiDecision}
      />
    </div>
  );
};

export default AiDecision;
